import { getSpeciesTeeth } from "duck";
import { DentalChartEnum, SpeciesEnum } from "requests";
import { Chart, Charts, FormValues } from "./types";

const resolveZero = (val: number | null | undefined) => val ?? null;

export const getDefaultValues = (
  dentalChart: Chart | null
): FormValues | null => {
  if (!dentalChart) {
    return null;
  }

  return {
    toothState: dentalChart.toothState || null,
    furcation: dentalChart.furcation || null,
    mobility: dentalChart.mobility || null,
    fracture: dentalChart.fracture || null,
    resorption: dentalChart.resorption || null,
    other: dentalChart.other || [],

    periodontalPocketMBuc: resolveZero(dentalChart.periodontalPocketMBuc),
    periodontalPocketBuccal: resolveZero(dentalChart.periodontalPocketBuccal),
    periodontalPocketDBuc: resolveZero(dentalChart.periodontalPocketDBuc),
    periodontalPocketMLingPal: resolveZero(
      dentalChart.periodontalPocketMLingPal
    ),
    periodontalPocketLingPal: resolveZero(dentalChart.periodontalPocketLingPal),
    periodontalPocketDLingPal: resolveZero(
      dentalChart.periodontalPocketDLingPal
    ),

    gingivalRecessionMBuc: resolveZero(dentalChart.gingivalRecessionMBuc),
    gingivalRecessionBuccal: resolveZero(dentalChart.gingivalRecessionBuccal),
    gingivalRecessionDBuc: resolveZero(dentalChart.gingivalRecessionDBuc),
    gingivalRecessionMLingPal: resolveZero(
      dentalChart.gingivalRecessionMLingPal
    ),
    gingivalRecessionLingPal: resolveZero(dentalChart.gingivalRecessionLingPal),
    gingivalRecessionDLingPal: resolveZero(
      dentalChart.gingivalRecessionDLingPal
    )
  };
};

export const handleChartChange = (
  species: SpeciesEnum | null,
  milkOrAdultTeeth: DentalChartEnum | null,
  selection: Charts,
  currentChart: Chart | null,
  dentalChartings: Charts
): { next: Chart | null; prev: Chart | null } => {
  let prev = null;
  let next = null;

  if (!currentChart) {
    return { prev, next };
  }

  if (selection.length > 1) {
    const currentIndex = selection.findIndex(
      chart => chart.tooth === currentChart.tooth
    );
    if (selection[currentIndex + 1]) {
      next = selection[currentIndex + 1];
    }
    if (selection[currentIndex - 1]) {
      prev = selection[currentIndex - 1];
    }
  } else {
    const teethNumbers = getSpeciesTeeth(species, milkOrAdultTeeth);
    const currentIndex = teethNumbers.findIndex(
      val => val === currentChart.tooth
    );
    const prevToothNumber =
      currentIndex === 0
        ? teethNumbers[teethNumbers.length - 1]
        : teethNumbers[currentIndex - 1];
    const nextToothNumber =
      currentIndex === teethNumbers.length - 1
        ? teethNumbers[0]
        : teethNumbers[currentIndex + 1];
    const prevTooth = dentalChartings.find(
      chart => chart.tooth === prevToothNumber
    );
    if (prevTooth) {
      prev = prevTooth;
    }
    const nextTooth = dentalChartings.find(
      chart => chart.tooth === nextToothNumber
    );
    if (nextTooth) {
      next = nextTooth;
    }
  }

  return { prev, next };
};
